import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=16175e00&"
import script from "./Manage.vue?vue&type=script&setup=true&lang=js&"
export * from "./Manage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports